var map = {
	"../pages/cadastro/cadastro.module": [
		372,
		13
	],
	"../pages/cardapio/cardapio.module": [
		373,
		12
	],
	"../pages/clube-historico/clube-historico.module": [
		374,
		11
	],
	"../pages/clube-menu/clube-menu.module": [
		375,
		10
	],
	"../pages/clube-regulamento/clube-regulamento.module": [
		376,
		9
	],
	"../pages/clube-resgates/clube-resgates.module": [
		377,
		8
	],
	"../pages/configuracoes/configuracoes.module": [
		379,
		7
	],
	"../pages/contato/contato.module": [
		378,
		6
	],
	"../pages/sugestoes/sugestoes.module": [
		380,
		5
	],
	"../pages/vinhos-categorias/vinhos-categorias.module": [
		381,
		4
	],
	"../pages/vinhos-classificacao/vinhos-classificacao.module": [
		382,
		3
	],
	"../pages/vinhos-detalhes/vinhos-detalhes.module": [
		383,
		2
	],
	"../pages/vinhos-subcategorias/vinhos-subcategorias.module": [
		384,
		1
	],
	"../pages/vinhos/vinhos.module": [
		385,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 184;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 184
// module chunks = 14